<app-carousel [typeSearch]="'Employee'"></app-carousel>
<div class="body-app mt-3 mb-3">
    <div class="content-app">
        <h5 class="mt-0 mb-2">
            <i class="fa-solid fa-house"></i>
            Inicio
        </h5>

        <hr class="mt-2 mb-2" />
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div *ngIf="isLoading" class="text-center my-3">
                                <div class="spinner-border" role="status">
                                    <span class="visually-hidden">Cargando...</span>
                                </div>
                                <p class="mt-2">Cargando información...</p>
                            </div>

                            <!-- Sección cuando no se ha encontrado la información del candidato -->
                            <div *ngIf="!isLoading && !isFound" class="alert alert-warning text-center" role="alert">
                                No se ha encontrado la información de la empresa.
                            </div>

                            <!-- Sección principal cuando se encontró la data -->
                            <div *ngIf="!isLoading && isFound">

                               <div class="row">
                                <div class="col-auto">
                                    <img [src]="logo" onerror="this.src='assets/Images/company.png'; this.error=null;" alt="Compania" class="img-fluid"
                                        style="max-width: 120px;" />
                                </div>
                                <div class="col">
                                    <h6 class="text-secondary mt-3 mb-0">
                                        Bienvenido
                                    </h6>
                                    <h3 class="text-primary mt-0 mb-1">
                                        {{company?.razonSocial}}
                                    </h3>
                                    <h6 class="text-secondary mt-1 mb-1">
                                        <i class="fa-regular fa-envelope"></i>
                                        {{company?.email}}
                                    </h6>
                                    <h6 class="text-secondary mt-1 mb-1">
                                        <i class="fa-solid fa-mobile-screen"></i>
                                       {{company?.legalRepPrimaryPhone}}
                                    </h6>
                                    <h6 class="text-secondary mt-1 mb-1">
                                        <i class="fa-solid fa-location-dot"></i>
                                        {{principalAddress?.stateName}}, {{principalAddress?.countryName}}
                                    </h6>
                                </div>
                               </div>
                            </div>

                        </div>
                        <!-- <hr />
                        <div class="row">
                            <div class="col-6">
                                <div class="row">
                                    <div class="col-auto">
                                        <i class="fa-solid fa-id-card-clip fa-3x text-primary mt-2"></i>
                                    </div>
                                    <div class="col">
                                        <h3 class="text-primary mt-0 mb-1">
                                            2
                                        </h3>
                                        <p>
                                            Ofertas publicadas
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="row">
                                    <div class="col-auto">
                                        <i class="fa-solid fa-file-contract fa-3x text-primary mt-2"></i>
                                    </div>
                                    <div class="col">
                                        <h3 class="text-primary mt-0 mb-1">
                                            75
                                        </h3>
                                        <p>
                                            Curriculums enviados
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <!-- <div class="card mb-2">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-auto">
                                <i class="fa-solid fa-person-running fa-5x text-primary mt-2"></i>
                            </div>
                            <div class="col">
                                <h1 class="text-primary mt-0 mb-1">
                                    1,522
                                </h1>
                                <p>
                                    Ofertas publicadas en el ultimo día
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mb-2">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-auto">
                                <i class="fa-solid fa-money-check-dollar fa-5x text-primary"></i>
                            </div>
                            <div class="col">
                                <h3 class="text-primary mt-0 mb-1">
                                    RD$ 1,520,450,445
                                </h3>
                                <p>
                                    Aproximados en concepto de nómina
                                </p>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <h5 class="mt-4 mb-2">
                    <i class="fa-solid fa-briefcase"></i>
                    Ultimos candidatos que aplicaron a sus ofertas
                </h5>
                <ul class="list-group">
                    <li class="list-group-item list-group-item-job" *ngFor="let item of candidates">
                        <div class="row align-items-center">
                            <div class="col-auto">
                                <img [src]="item.photoUrl" alt="Foto" class="img-fluid" 
                                    style="max-width: 50px; border-radius: 50%; object-fit: cover;" onerror="this.error=null; this.src='assets/Images/no-image.jpg'" />
                            </div>
                            <div class="col">
                                <h6 class="text-secondary mt-3 mb-0">
                                    {{item.firstName}} {{item.lastName}}
                                </h6>
                                <h6 class="text-secondary mt-1 mb-1">
                                    <i class="fa-solid fa-envelope"></i>
                                    {{item.email}}
                                </h6>
                                <h6 class="text-secondary mt-1 mb-1">
                                    <i class="fa-solid fa-mobile-screen"></i>
                                    {{item.cellPhone}}
                                </h6>
                            </div>
                            <div class="col-auto d-flex flex-column p-2">
                                <h6>
                                    <i class="fa-solid fa-briefcase text-primary me-1"></i>
                                    {{item.jobTitle}}
                                </h6>
                                <a class="btn btn-outline-primary" routerLink="/companies/job-offer-details/{{item.jobOfferId}}">
                                    <i class="fa-solid fa-eye"></i>
                                </a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>